import React, {useContext, useEffect} from 'react';
import {Link} from 'react-router-dom'

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DataGrid } from '@mui/x-data-grid';
import Container from '@mui/material/Container';

import {Loading} from '../custom/LoadingComponent'
import * as TypeConvertor from '../util/TypeConvertor';
import BucketContext from '../context/BucketContext';


function SysUsers(props) {
    console.log("___ SysUsers ___");

    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData();
    }, []);

    const columns = [
        {
            field: 'userName',
            headerName: 'Utilizator',
            width: 250,
            valueGetter: (params) => params.row.generalSection.username,
            renderCell: (params) => {
                return(
                    <Link to={`/sysusers/${params.row.id}`}>
                        {params.row.generalSection.username}
                    </Link>
                );
            }
        },
        {
            field: 'lastName',
            headerName: 'Nume',
            width: 150,
            valueGetter: (params) => params.row.generalSection.lastName
        },
        {
            field: 'firstName',
            headerName: 'Prenume',
            width: 150,
            valueGetter: (params) => params.row.generalSection.firstName
        },
        {
            field: 'activeUser',
            type: 'boolean',
            headerName: 'Activ',
            width: 50,
            valueGetter: (params) => params.row.generalSection.active
        },
        {
            field: 'roleName',
            headerName: 'Rol',
            width: 225,
            valueGetter: (params) => TypeConvertor.getRoleDescription( params.row.generalSection.role )
        }
    ];

    if (props.users.isLoading) {
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                <Loading />
            </Box>
            </Container>
        );
    }
    else { 
        return(
            <React.Fragment>
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Utilizatori CorEvo</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <Box style={{display:"flex", marginBottom: 4}}>
                            <h3>Utilizatori</h3>
                            <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                                <Link to={'/sysusers/newuser'}>
                                    <Button variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Utilizator</Button>
                                </Link>
                            </Box>
                        </Box>                
                    </Box>
                    <hr />
    
                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        <DataGrid
                            getRowId={(row) => row.type + '_' + row.id}
                            rows={props.users.users}
                            columns={columns}
                            initialState={{
                                sorting: { sortModel: [{ field: 'userName', sort: 'asc' }] }
                            }}                            
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                        />
                    </Box>
                </Stack>

            </Box>
            </Container>
            </React.Fragment>
        );
    }
}

export default SysUsers;